import React from "react";
import Box, { BoxProps } from "../box/Box";
import { useInputStyle, IInput } from "./Input";
import theme from "../theme/theme";

interface IInputAddon {
  /**
   * The content of the `InputAddon`
   */
  children: React.ReactNode;
  /**
   * The size of the addon is inherited from the `InputGroup` via `cloneElement`.
   */
  size?: IInput["size"];
  /**
   * The position the addon should appear relative to the `Input`.
   * We added `InputLeftAddon` and `InputRightAddon` so you might not need to pass this
   */
  placement?: "left" | "right";
}

export type InputAddonProps = IInputAddon & BoxProps;

const InputAddon: React.FC<InputAddonProps> = ({ placement = "left", size = "md", ...props }) => {
  const _placement = {
    left: {
      mr: "-1px",
      roundedRight: 0,
      borderRightColor: "transparent",
    },
    right: {
      order: 1,
      roundedLeft: 0,
      borderLeftColor: "transparent",
    },
  };

  const styleProps = {
    ...useInputStyle({ size, variant: "outline" }),
    flex: "0 0 auto",
    whiteSpace: "nowrap",
    bg: theme.colors.gray[200],
    ..._placement[placement],
  };

  // @ts-ignore
  return <Box {...styleProps} {...props} />;
};

export const InputLeftAddon: React.FC<InputAddonProps> = props => <InputAddon placement="left" {...props} />;
export const InputRightAddon: React.FC<InputAddonProps> = props => <InputAddon placement="right" {...props} />;

export default InputAddon;
